import { makeStyles } from '@mui/styles';
import { COLORS } from '../../../EatClubTheme';

const useStyles = makeStyles(
  (theme) => ({
    content: {
      display: 'flex',
      flexDirection: 'column',
      gap: '24px',
      paddingTop: '8px',
    },
    tag: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '6px 12px',
      border: '1px solid #000',
      borderRadius: '8px',
      backgroundColor: '#FCFCCF',
      color: '#313131',
      fontSize: '12px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: 'normal',
      letterSpacing: '1.2px',
      textTransform: 'uppercase',
      width: 'fit-content',
      marginBottom: '-10px',
      [theme.breakpoints.down('md')]: {
        fontSize: '11px',
        padding: '5px 10px',
        marginBottom: '-8px',
      },
    },
    title: {
      color: '#1A1919',
      fontSize: '36px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '42px',
      marginBottom: '12px',
      [theme.breakpoints.down('md')]: {
        fontSize: '24px',
        lineHeight: '30px',
        marginBottom: '8px',
      },
    },
    introText: {
      color: '#6E6E6D',
      fontSize: '18px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '24px',
      maxWidth: '480px',
      marginBottom: '32px',
      [theme.breakpoints.down('md')]: {
        fontSize: '14px',
        lineHeight: '20px',
        marginBottom: '20px',
      },
    },
    optionsList: {
      display: 'flex',
      flexDirection: 'column',
      gap: '32px',
      [theme.breakpoints.down('md')]: {
        gap: '20px',
      },
    },
    optionRow: {
      display: 'flex',
      alignItems: 'center',
      gap: '20px',
      width: '100%',
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '16px',
      },
    },
    iconContainer: {
      width: '100px',
      height: '100px',
      borderRadius: '12px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      '& svg': {
        width: '70px',
        height: '70px',
      },
      [theme.breakpoints.down('md')]: {
        width: '80px',
        height: '80px',
        borderRadius: '10px',
        '& svg': {
          width: '36px',
          height: '36px',
        },
      },
    },
    imageIcon: {
      width: '60px',
      height: 'auto',
      [theme.breakpoints.down('md')]: {
        width: '50px',
        height: 'auto',
      },
    },
    optionContent: {
      flex: 1,
      minWidth: 0,
      gap: '16px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      height: '100px', // Match icon container height
      [theme.breakpoints.down('md')]: {
        height: 'auto',
        width: '100%',
        gap: '8px',
      },
    },
    optionTitle: {
      color: '#313131',
      fontSize: '22px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '24px',
      [theme.breakpoints.down('md')]: {
        fontSize: '16px',
        lineHeight: '20px',
      },
    },
    optionDescription: {
      color: '#6E6E6D',
      fontSize: '14px',
      fontStyle: 'normal',
      maxWidth: '250px',
      fontWeight: 400,
      lineHeight: '16px',
      [theme.breakpoints.down('md')]: {
        fontSize: '13px',
        lineHeight: '18px',
      },
    },
    optionAction: {
      display: 'flex',
      alignItems: 'flex-end',
      flexShrink: 0,
      height: '100px',
      paddingBottom: '15px',
      [theme.breakpoints.down('md')]: {
        height: 'auto',
        width: '100%',
        paddingBottom: '0',
        alignItems: 'flex-start',
      },
    },
    enabledStatus: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      [theme.breakpoints.down('md')]: {
        width: '100%',
      },
    },
    enabledText: {
      color: '#6E6E6D',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '20px',
      whiteSpace: 'nowrap',
      [theme.breakpoints.down('md')]: {
        fontSize: '13px',
        whiteSpace: 'normal',
      },
    },
    buttonWrapper: {
      width: '100%',
      [theme.breakpoints.down('md')]: {
        '& button': {
          width: '100% !important',
        },
      },
    },
    divider: {
      width: '100%',
      height: '1px',
      backgroundColor: '#E0E0E0',
      margin: '0px',
    },
  }),
  { name: 'AudienceTargetingModal' },
);

export const getModalInputStyle = () => ({
  button: {
    backgroundColor: COLORS.BRAND_YELLOW,
    color: '#1A1919',
    fontWeight: 400,
    '&:hover': {
      backgroundColor: COLORS.PROFIT_YELLOW_DARK,
    },
  },
  cancelButton: {
    fontWeight: 400,
  },
});

export const getModalStyle = () => ({
  content: {
    maxWidth: '800px',
  },
  footer: {
    position: 'relative',
  },
});

export default useStyles;
